/* ========== ~~~~~~~~~~ EMBED STATUS : ACTIONS ~~~~~~~~~~ ========== */
// ACTION
// utilized by reducers as a call to action to perform some kind of update to application state
// utilized in "_container" components and reducers



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const SET_INVIEW_STATUS = "SET_INVIEW_STATUS";
export const SET_INTEGRATION_TYPE_AND_URL = 'SET_INTEGRATION_TYPE_AND_URL';
export const SET_OUT_OF_CONTENT = 'SET_OUT_OF_CONTENT';
export const SHOW_LOADER = 'SHOW_LOADER';

export const setInViewStatus = inViewStatus => ({
    type: SET_INVIEW_STATUS,
    inViewStatus
});
export const setIntegrationTypeAndURL = integrationTypeAndURL => ({
    type: SET_INTEGRATION_TYPE_AND_URL,
    integrationTypeAndURL
});
export const setOutOfContent = status => ({
    type: SET_OUT_OF_CONTENT,
    status
});

export const showLoader = state => ({
    type: SHOW_LOADER,
    state
});
